export default __webpack_public_path__ + "static/media/bg-our-approach.08dbd35c.png";